import {KeycloakConfig} from 'keycloak-js';

export const environment = {
  production: true,
  baseURL: '/api',
  auth: {
    url: 'https://fit.uni-kassel.de/auth',
    realm: 'FIT',
    clientId: 'web',
  } satisfies KeycloakConfig,
  sentry: {
    // https://clashsoft.sentry.io/issues/?project=4508012203278336
    dsn: 'https://685fc68997985ac30ada718081895105@o416265.ingest.us.sentry.io/4508012203278336',
    environment: 'production',
    release: 'v3.x',
    tracesSampleRate: 1,
    profilesSampleRate: 0.1,
  },
  topics: '/topics',
  articles: '/articles',
  users: '/users',
  institutions: '/institutions',
  statistics: '/statistics',
  internalMessages: '/internalMessages',
  mailing: '/mailing',
  adminMail: '/adminMail',
  contacts: '/contacts',
  admin: '/admin',
};
